import { useState } from 'react';

const useForceUpdate = () => {
  // eslint-disable-next-line no-unused-vars
  const [_, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update state to force render
};

export default useForceUpdate;
